// İSG uzmanı portalı — Ayarlar (Settings) erişim kapısı (route guard UX).
//
// Asıl yetki backend'dedir (`[ModuleAction("companies"|"branches"|"sites", …)]`);
// bu kapı yalnız UX'tir: firma sondasının (useSettingsAccess) sonucuna göre Ayarlar
// kabuğunu, 403 sayfasını veya "kullanılamıyor" durumunu gösterir. `granted` →
// Ayarlar kabuğu (Outlet). §9 admin kapısından (AdminGate) ayrıdır — Ayarlar tenant
// yöneticisine açıktır (sistem-admin şartı yok).

import { Button, Card, CardContent, Spinner } from '@isgportal/shared';
import { SlidersHorizontal, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useSettingsAccess } from '../../lib/settingsAccess';
import { SettingsShell } from './SettingsShell';

export function SettingsGate() {
  const { t } = useTranslation();
  const access = useSettingsAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner label={t('settings.gate.loadingLabel')} />
      </div>
    );
  }

  if (access.status === 'forbidden') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <SlidersHorizontal className="h-10 w-10 text-danger" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('settings.forbidden.title')}</h1>
              <p className="text-sm text-muted">{t('settings.forbidden.body')}</p>
            </div>
            <Button asChild variant="secondary">
              <Link to="/">{t('settings.forbidden.back')}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (access.status === 'unavailable') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <TriangleAlert className="h-10 w-10 text-warning-foreground" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('settings.unavailable.title')}</h1>
              <p className="text-sm text-muted">{t('settings.unavailable.body')}</p>
            </div>
            <Button onClick={access.refetch}>{t('settings.unavailable.retry')}</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <SettingsShell />;
}
